<div class="header">
  <div class="header__left">
    <button 
      class="menu-toggle"
      (click)="onMenuToggle()"
      [attr.aria-label]="'layout.header.toggleMenu' | translate">
      <i class="pi pi-bars"></i>
    </button>
    <h1 class="header__title">{{ title | translate }}</h1>
  </div>
  <div class="header__actions">
    <div class="language-selector">
      <button 
        class="language-button"
        (click)="menu.toggle($event)"
        [attr.aria-label]="'layout.header.changeLanguage' | translate">
        <i class="pi pi-globe"></i>
        <span class="current-flag">{{ getCurrentCode() }}</span>
      </button>
      <p-menu 
        #menu
        [model]="menuItems"
        [popup]="true"
        appendTo="body">
        <ng-template #item let-item>
          <div class="language-menu-item">
            <span class="language-flag">{{ item.code }} - </span>
            <span class="language-label">{{ item.label }}</span>
          </div>
        </ng-template>
      </p-menu>
    </div>
    <!-- <button class="theme-toggle-btn" (click)="toggleTheme()" [attr.aria-label]="isDarkTheme ? 'Tema claro' : 'Tema oscuro'">
      <i class="fas" [ngClass]="isDarkTheme ? 'fa-sun' : 'fa-moon'"></i>
    </button> -->
  </div>
</div> 